import React, { useState } from 'react';
import CollapseWrapper from '@hpstellar/core/CollapseWrapper';
import WordCloud from '@hpstellar/core/WordcloudOld';
import Link from '@hpstellar/core/Link';
import withWindowResize from '../../../ui/components/window-resize';

import withPageComponents from '../with-page-components';
import DisclaimerList from '../disclaimer-list';

import './disclaimer-tabs.less';

const getTabs = wordCloud => {
    let tabs = [];
    if (wordCloud && wordCloud.length > 0) {
        tabs.push({
            title: 'More Useful Links',
            Component: <WordCloud links={wordCloud} />,
        });
    }
    tabs.push({
        title: 'Disclaimer',
        Component: <DisclaimerList />,
    });
    return tabs;
};

const toggleTab = (setTabIndex, tabIndex, index) => () => {
    if (index === tabIndex) {
        setTabIndex(-1);
    } else {
        setTabIndex(index);
    }
};

const disclaimerTabs = ({ width, wordCloud = [] }) => {
    const [tabIndex, setTabIndex] = useState(-1);

    const tabs = getTabs(wordCloud);
    if (width < 1024) {
        return (
            <>
                {tabs.map((t, i) => {
                    return (
                        <CollapseWrapper title={t.title} key={`${t.title}-${i}`} accordionProps={{ size: 'small' }}>
                            {t.Component}
                        </CollapseWrapper>
                    );
                })}
            </>
        );
    }
    return (
        <div className={`disclaimer-tabs${tabIndex > -1 ? ' expanded' : ''}`}>
            <div className="tabs-title">
                {tabs.map((t, i) => (
                    <Link
                        key={`${t.title}-${i}`}
                        variation={'primary'}
                        color="dark"
                        onClick={toggleTab(setTabIndex, tabIndex, i)}
                        preventDefault
                        icon={'angle'}
                    >
                        {t.title}
                    </Link>
                ))}
            </div>
            {tabIndex > -1 && tabs[tabIndex].Component}
        </div>
    );
};

export default withPageComponents(withWindowResize(disclaimerTabs), { device: true });
